import { getCDNImageUrl } from "@/utils/Common";
import React from "react";

const Placeholder = (props) => {
  const { title, message = "", image, alt, buttonText, onButtonClick } = props;
  return (
    <div className="p-[45px] text-center">
      <img
        src={image ?? getCDNImageUrl("error-page-placeholder.webp")}
        alt={alt ?? "Error state"}
        className="w-auto h-36 object-cover mx-auto mb-4"
      />
      <div>
        <h2 className="font-semibold text-2xl mb-2">
          {title ?? "No Data Available"}
        </h2>
        <p className="text-lg">{message}</p>
        {buttonText ? (
          <button
            onClick={onButtonClick}
            className="w-[150px] py-2.5 px-8 me-2 mb-2 mt-5 text-sm font-medium bg-red text-[#FFF] rounded-[4px]"
          >
            {buttonText}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Placeholder;
